import React from 'react';

import containers from '../../containers';
import components from '../../components';
import TimezoneInfo from '../../components/timezoneInfo';
import { useSelector } from 'react-redux';
import { getUser } from '../../redux/user/actions';

import './styles.scss';

const { ProfileContainer } = containers;
const { Header, NotificationTools } = components;

const Profile = ({ documentationEnabled }) => {
  const user = useSelector(getUser);
  return (
    <div className="profile-screen d-flex flex-column flex-fill">
      <Header
        title={'Profile'}
        icon={'userDark'}
        actions={
          user && user.type !== 'BRAND'
            ? [
                { type: 'reactComponent', value: <TimezoneInfo key="timezone-info" /> },
                { type: 'reactComponent', value: <NotificationTools key="0" /> }
              ]
            : []
        }
      />
      <ProfileContainer documentationEnabled={documentationEnabled} />
    </div>
  );
};

export default Profile;
